import angular from 'angular';

import slingTipComponent from './components/slingTipComponent';
import dotsCarouselComponent from './components/dotsCarouselComponent';
import educationAppendContent from './directives/educationAppendContent';
import EducationImport from './Education';
import educationScopeDirective from './directives/educationScope';

const educationModule = angular.module('sling.education', []);
export default educationModule.name;

educationModule.service('Education', EducationImport);
educationModule.component('slingTip', slingTipComponent);
educationModule.component('dotsCarousel', dotsCarouselComponent);
educationModule.directive('educationScope', educationScopeDirective);
educationModule.directive('educationAppendContent', educationAppendContent);
